import axios from 'axios';

var token = sessionStorage.getItem("token") || localStorage.getItem("token");

const api = axios.create({
  baseURL: 'https://api.cervet.com.br/api/',
  // baseURL: 'http://localhost:8000/api/',
  headers: {
    Authorization: token,
  },
});


export default api;
